import React from 'react';
import Typography from '@mui/material/Typography';
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";

export default function SeaQuoteSummary(props) {
    const { quoteDetails } = props;

    const handleBookingReferenceClick = (shipmentId) => {
        if (shipmentId) {
            return window.location.href = '/LeoSeaPortal/bookingdetails?shipmentId=' + shipmentId + ''
        }
    };

    return (
        <>
            <GridContainer>
                <GridItem xs={3}>
                    <Typography fontWeight={700}>Europa Reference</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.shipmentRef}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Quote Valid To Date</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.validToDate}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Shipper</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.shipper}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Consignee</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.consignee}
                    </Typography>
                </GridItem>
            </GridContainer>

            <GridContainer>
                <GridItem xs={3}>
                    <Typography fontWeight={700}>Delivery Address</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.deliveryAddress}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Port of Loading</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.sourceTerminal}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Port of Discharge</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.destinationTerminal}
                    </Typography>
                </GridItem>
            </GridContainer>

            <GridContainer>
                <GridItem xs={3}>
                    <Typography fontWeight={700}>Cargo Mode</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.cargoMode}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Term Type</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.termTypeCode}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Total Cost &pound; *</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {quoteDetails.totalCharge}
                    </Typography>
                </GridItem>

                {quoteDetails.associatedShipmentRef && 
                    <GridItem xs={3}>
                        <Typography fontWeight={700}>Booking Reference</Typography>
                        <Typography onClick={() => handleBookingReferenceClick(quoteDetails.webPortalAssociatedShipment.associatedShipmentID)} style={{ cursor: 'pointer' }} variant="body2" color="text.secondary">
                            <u>{quoteDetails.associatedShipmentRef}</u>
                        </Typography>
                    </GridItem>
                }
            </GridContainer>
        </>
    );
}

